import React from 'react';
import ReportContent from "./content/report-content.jsx";
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";

const Content = ({reportData, entity, title, printComponentRef, setLoading, reloadReportTrigger, setCurrentTotal, setCanPrint, showMoreInformation}) => {
    return (
        <>
            {
                reportData && (
                    <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setLoading}>
                        <div className={"w-full mt-[25px] print:mt-[0]"}>
                            <ReportContent data={reportData} reloadReportTrigger={reloadReportTrigger} setCurrentTotal={setCurrentTotal} setCanPrint={setCanPrint} showMoreInformation={showMoreInformation}/>
                        </div>
                    </PrintTemplate>
                )
            }
        </>
    );
};

export default Content;
